
import { useNavigation } from '@react-navigation/native';
import { APIData } from '../constants';
import useRest from './base/useRest';

// CONTACTS

const preffix = "taxes";

export const useTax = (options?: APIData) => {
    return useRest(`${preffix}/`, options);
};